import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
let loading
let reqNum = 0
function startLoading() { // 使用Element loading-start 方法
  if (reqNum === 0) {
    // store.dispatch('permission/setLoading', true)
    // loading = Loading.service({
	// 	lock: true,
	// 	text: 'loading',
	// 	background: 'rgba(0, 0, 0, 0.7)'
  	// })
  }
  reqNum++
}
function endLoading() { // 使用Element loading-close 方法
  if (reqNum <= 0) return
  reqNum--
  if (reqNum === 0) {
    // loading.close()
    // store.dispatch('permission/setLoading', false)
  }
}

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  // baseURL: window.origin,
  withCredentials: true // 跨域请求时发送 cookies
  // timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    if (store.getters.token) {
	  // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers['authorization'] = localStorage.getItem('Authorization')
    }
    startLoading()
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get information such as headers or status
   * Please return  response => response
  */
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 XMLHttpRequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
	endLoading()
    const res = response.data
    if (res.code != 200) {
		if (res.code == 401) {
			window.location.href = window.location.origin+'/';
			localStorage.removeItem('Authorization');
		}else if(res.code == 501){
			console.log(res.code +":"+res.msg)
		}else {
			Message({
				message: res.msg,
				type: 'error',
				duration: 2 * 1000
			})
		}
		return Promise.reject('error')
    } else {
    	return res
    }
  },
  error => {
    endLoading()
    if (error.response.status == 401) {
		window.location.href = window.location.origin+'/';
		localStorage.removeItem('Authorization');
	}else if(error.response.status == 501){
		console.log(error.response.status +":"+error.message)
	}else {
		Message({
			message: error.message,
			type: 'error',
			duration: 2 * 1000
		})
	}
    return Promise.reject(error)
  }
)

export default service
